import React, { useState, useEffect, useCallback, useContext } from "react";
import './manageRole.scss';
import DataTable from "react-data-table-component";
import { RoleExpand } from "./RoleExpand";
import masterApi from "../../../services/masterApi";
import { RoleContext } from "./roleContext";

export const SecondStepperCont = ({ setSaveFunction, existingdata ,viewOnly, setPermissionValidator}) => {
  const {roleFunctionalities, setRoleFunctionalities, expandedData, setExpandedData} = useContext(RoleContext);

  const [selectAllState, setSelectAllState] = useState({
    view: false,
    create: false,
    edit: false,
    delete: false,
  });

  // Fetch Data on Mount
  useEffect(() => {
    fetchData();
  }, []);
  // Save Function using useCallback
  const SaveRoleFunctionalities = useCallback(async (roleId) => {    
    const combinedArray = [...roleFunctionalities, ...expandedData];    
    const requestData = {
      roleId,
      roleFunctionalities: combinedArray
    };
    // debugger;
    const response = await masterApi.createOrUpdateRoleMappings(requestData);
    console.log("createOrUpdateRoleMappings",response);
    // debugger;
    if(response?.response?.ok){
      alert("Role Saved Successfully");
    }
  }, [roleFunctionalities, expandedData]);
  // }, [roleRunner]);


  // useEffect(() => {
  //   setSaveFunction(() => SaveRoleFunctionalities);
  // // }, [SaveRoleFunctionalities, setSaveFunction]);
  // }, []);

  // Add validator function for permissions
  const validatePermissions = () => {
    const combinedArray = [...roleFunctionalities, ...expandedData];
    return combinedArray.some(item =>
      item.view || item.create || item.edit || item.delete
    );
  };

  // useEffect(() => {
  //   setPermissionValidator(() => validatePermissions);
  // // }, [validatePermissions, setPermissionValidator]);
  // }, []);

  // Fetch Role Functionalities
  const fetchData = async () => {
    try {
      const response = await masterApi.getRoleFunctionalities(existingdata || 0);
      const rfList = response?.data?.rolefunctionalities || [];
      const filteredRfList = rfList.filter(item => item.mainFunctionalityId === null);
      const filteredRfListExp = rfList.filter(item => item.mainFunctionalityId !== null);

      setRoleFunctionalities(filteredRfList);
      setExpandedData(filteredRfListExp);
    } catch (error) {
      console.error("Error fetching role functionalities:", error);
    }
  };

  const handleCheckboxChange = (id, field) => {
    setRoleFunctionalities(prevState => {
      const updatedState = prevState.map(item =>
        item.id === id ? { ...item, [field]: !item[field] } : item
      );
      return updatedState;
    });
  };

  const updateFunctionality = (id, field) => {
    setExpandedData(prevState => {
      const updatedState = prevState.map(item =>
        item.id === id ? { ...item, [field]: !item[field] } : item
      );
      return updatedState;
    });
  };

  // checkall
  const handleSelectAllColumn = (field) => {
    const isChecked = !selectAllState[field];

    const updatePermissions = (dataList) =>
      dataList.map(item => ({
        ...item,
        [field]: item[`${field}Enable`] && !viewOnly ? isChecked : item[field],
      }));

    setRoleFunctionalities(prev => updatePermissions(prev));
    setExpandedData(prev => updatePermissions(prev));

    setSelectAllState(prev => ({
      ...prev,
      [field]: isChecked
    }));
  };

  const renderSelectAllHeader = (label, field) => (
    <div className="text-center w-100">
      <input
        type="checkbox"
        checked={selectAllState[field]}
        onChange={() => handleSelectAllColumn(field)}
        disabled={viewOnly}
      />
      <div>{label}</div>
    </div>
  );
  //checkall
  // DataTable Columns
  const columns = [
    {
      name: "Page Name",
      selector: row => row.functionalityDisplayName,
      sortable: true
    },
    {
      // name: "View",
      name: renderSelectAllHeader("View", "view"),
      width: "100px",
      cell: row => (
        <div className="text-center w-100">
          <input
            type="checkbox"
            disabled={!row.viewEnable||viewOnly}
            checked={row.view}
            onChange={() => handleCheckboxChange(row.id, "view")}
          />
        </div>
      )
    },
    {
      // name: "Create",
      name: renderSelectAllHeader("Create", "create"),
      width: "100px",
      cell: row => (
        <div className="text-center w-100">
          <input
            type="checkbox"
            disabled={!row.createEnable||viewOnly}
            checked={row.create}
            onChange={() => handleCheckboxChange(row.id, "create")}
          />
        </div>
      )
    },
    {
      // name: "Edit",
      name: renderSelectAllHeader("Edit", "edit"),
      width: "100px",
      cell: row => (
        <div className="text-center w-100">
          <input
            type="checkbox"
            disabled={!row.editEnable||viewOnly}
            checked={row.edit}
            onChange={() => handleCheckboxChange(row.id, "edit")}
          />
        </div>
      )
    },
    {
      // name: "Delete",
      name: renderSelectAllHeader("Delete", "delete"),
      width: "100px",
      cell: row => (
        <div className="text-center w-100">
          <input
            type="checkbox"
            disabled={!row.deleteEnable||viewOnly}
            checked={row.delete}
            onChange={() => handleCheckboxChange(row.id, "delete")}
          />
        </div>
      )
    }
  ];

  return (
    <section className="datatable-holder">
      <DataTable
        columns={columns}
        data={roleFunctionalities}
        expandableRows
        expandableRowExpanded={row => row.hasSubFunctionalities}
        expandableRowsComponent={({ data }) => (
          <RoleExpand
            data={expandedData.filter(item => item.mainFunctionalityId === data.id)}
            updateFunctionality={updateFunctionality}
            viewOnly={viewOnly}
          />
        )}
      />
    </section>
  );
};
